import { Amplify } from 'aws-amplify';
import { Authenticator, Theme, ThemeProvider, View } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import NavigationBar from './Navigation/Navbar';
import amplifyConfig from "./amplifyconfig.json";
import { loginScreen } from './styles/app';
import { useTheme, useAuthenticator } from '@aws-amplify/ui-react';
import { Text, Heading } from '@aws-amplify/ui-react';
import Icon from './Images/PostOfficeLogo';

Amplify.configure(amplifyConfig);

const components = {
  Header() {
    const { tokens } = useTheme();

    return (
      <View textAlign="center" padding={tokens.space.large} >
        <Icon />
      </View>
    );
  },
  Footer() {
    const { tokens } = useTheme();

    return (
      <View textAlign="center" padding={tokens.space.large}>
        <Text style={loginScreen.rightsText}>
          &copy; All Rights Reserved
        </Text>
      </View>
    );
  },
  SignIn: {
    Header() {
      const { tokens } = useTheme();

      return (
        <Heading
          padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
          level={3}
        >
          Sign in
        </Heading>
      );
    },
    Footer() {
      return (
        <View textAlign="center"></View>
      );
    },
  },
}

const formFields = {
  signIn: {
    username: {
      label: 'Email',
      placeholder: 'Enter your email',
      labelHidden: false,
    },
    password: {
      label: 'Password',
      placeholder: 'Enter your Password:',
      labelHidden: false,
    },
  },
  forceNewPassword: {
    password: {
      placeholder: 'Enter your Password:',
    },
  },
  setupTOTP: {
    QR: {
      totpIssuer: 'TAM Backoffice',
    },
    confirmation_code: {
      placeholder: 'Enter your Confirmation Code:',
      isRequired: false,
    },
  },
  confirmSignIn: {
    confirmation_code: {
      placeholder: 'Enter your Confirmation Code:',
      isRequired: false,
    },
  },
};

const theme = {
  name: 'custom-theme',
  tokens: {
    components: {
      card: {
        backgroundColor: { value: '{colors.neutral[10]}' },
        outlined: {
          borderColor: { value: '{colors.black}' },
        },
      },
      heading: {
        color: { value: '{colors.black}' },
      },
      text: {
        color: { value: '{colors.brand.primary[80]}' },
      },
      button: {
        primary: {
          color: { value: '{colors.white}' },
          backgroundColor: { value: '{colors.red[80]}' },
          hover: {
            backgroundColor: { value: '{colors.red[90]}' },
          },
          active: {
            backgroundColor: { value: '{colors.red[100]}' },
          }
        }
      }
    },
  },
};

const App = () => {
  if(window.self === window.top) {
    return (
      <div style={loginScreen.background}>
        <div style={loginScreen.loginInput}>
          <ThemeProvider theme={theme}>
            <Authenticator hideSignUp={true} components={components} formFields={formFields}>
              { ({signOut}) => (
                <div style={loginScreen.innerAppView}>
                  <NavigationBar signOut={signOut}/>
                </div>
              )}
            </Authenticator>
          </ThemeProvider>
        </div>
      </div>
    );
  } else {
      return (<div>Invalid request.</div>);
  }
}

export default App;